import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started--installation"
    }}>{`Getting Started & Installation`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Make sure you moved the `}<inlineCode parentName="p">{`pickbazar-react`}</inlineCode>{` folder to a generic folder like `}<inlineCode parentName="p">{`Desktop,`}</inlineCode>{` `}<inlineCode parentName="p">{`Document,`}</inlineCode>{` or your specific code folder. Otherwise, the top folder name causes several path issues in generating the schema or installing npm packages.`}</p>
    </blockquote>
    <p>{`For getting started with the template you have to follow the below procedure. First navigate to the `}<inlineCode parentName="p">{`root`}</inlineCode>{` directory. Then run below command for getting started with specific part.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on root directory
yarn
`}</code></pre>
    <h2 {...{
      "id": "api-nestjs-graphql"
    }}>{`API (NestJs GraphQL)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/graphql`}</inlineCode>{` directory and run below command.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on api/graphql directory
yarn
yarn start:dev
`}</code></pre>
    <p><strong parentName="p">{`NOTE`}</strong>{` : This will start the server at `}<inlineCode parentName="p">{`http://localhost:4000`}</inlineCode>{` for graphql api and you can access it from browser at `}<inlineCode parentName="p">{`http://localhost:4000/graphql`}</inlineCode>{`(for graphql playground).`}</p>
    <h2 {...{
      "id": "api-nestjs-rest"
    }}>{`API (NestJs REST)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/rest`}</inlineCode>{` directory and run below command.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on api/rest directory
yarn
yarn start:dev
`}</code></pre>
    <p><strong parentName="p">{`NOTE`}</strong>{` : This will start the server at `}<inlineCode parentName="p">{`http://localhost:5000/api/`}</inlineCode>{` for rest api and you can access it from browser at `}<inlineCode parentName="p">{`http://localhost:5000/docs`}</inlineCode>{`(for rest swagger doc).`}</p>
    <h2 {...{
      "id": "admingraphql"
    }}>{`Admin(GraphQL)`}</h2>
    <p>{`For starting the admin dashboard part with corresponding api data run below commands.`}</p>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/admin/graphql`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Copy the contents of `}<inlineCode parentName="li">{`.env.template`}</inlineCode>{` into a new file called `}<inlineCode parentName="li">{`.env`}</inlineCode></li>
      <li parentName="ol">{`Run below command to start the server.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on root directory
yarn dev:admin-gql
# or
# on admin/graphql directory
yarn dev

`}</code></pre>
    <h2 {...{
      "id": "adminrest"
    }}>{`Admin(REST)`}</h2>
    <p>{`For starting the admin dashboard part with corresponding api data run below commands.`}</p>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/admin/rest`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Copy the contents of `}<inlineCode parentName="li">{`.env.template`}</inlineCode>{` into a new file called `}<inlineCode parentName="li">{`.env`}</inlineCode></li>
      <li parentName="ol">{`Run below command to start the server.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on root directory
yarn dev:admin-rest
# or
# on admin/rest directory
yarn dev

`}</code></pre>
    <h2 {...{
      "id": "shop"
    }}>{`Shop`}</h2>
    <p>{`For starting the shop part with corresponding api run below commands.`}</p>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/shop`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Copy the contents of `}<inlineCode parentName="li">{`.env.template`}</inlineCode>{` into a new file called `}<inlineCode parentName="li">{`.env`}</inlineCode></li>
      <li parentName="ol">{`Fill the `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file with your values like, `}<inlineCode parentName="li">{`NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY=, SECRET=, GOOGLE_CLIENT_ID=, GOOGLE_CLIENT_SECRET=`}</inlineCode></li>
      <li parentName="ol">{`SET `}<inlineCode parentName="li">{`FRAMEWORK_PROVIDER='yourProjectType'`}</inlineCode>{` in `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. ex: if you want to use rest then `}<inlineCode parentName="li">{`FRAMEWORK_PROVIDER='rest'`}</inlineCode>{` or `}<inlineCode parentName="li">{`FRAMEWORK_PROVIDER='graphql'`}</inlineCode></li>
      <li parentName="ol">{`SET `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{`. if you want to use `}<inlineCode parentName="li">{`rest version`}</inlineCode>{` then copy the content from `}<inlineCode parentName="li">{`tsconfig.rest.json`}</inlineCode>{` to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{` file or if you want to use `}<inlineCode parentName="li">{`graphql version`}</inlineCode>{` then copy the content from `}<inlineCode parentName="li">{`tsconfig.graphql.json`}</inlineCode>{` to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{` file.`}</li>
      <li parentName="ol">{`Run below command to start the server.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on root directory

yarn dev:shop-gql
yarn dev:shop-rest

# or
# on shop directory
yarn dev:rest
yarn dev:gql

`}</code></pre>
    <p><strong parentName="p">{`NOTE`}</strong>{` : API must be running for the above commands to work.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` : `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file must be filled with your values.`}</p>
    <h2 {...{
      "id": "only-for-windows-users"
    }}>{`Only For Windows Users`}</h2>
    <pre><code parentName="pre" {...{}}>{`- Go to your specific project root and find \`.graphql-let.yml\`
- Replace the env variable \`\${NEXT_PUBLIC_GRAPHQL_API_ENDPOINT}\` in schema field manually
- Provide your API url in the schema field.
- Also change the dev command at \`package.json\`
- Go to \`shop/package.json\` and \`admin/package.json\` file and change the scripts:

"codegen": "node -r dotenv/config $(yarn bin)/graphql-let",
to
"codegen": "graphql-let",
`}</code></pre>
    <h1 {...{
      "id": "if-you-want-to-test-your-production-build-admin-or-shop-in-local-environment-then-run-the-below-commands"
    }}>{`If you want to test your production build admin or shop in local environment then run the below commands.`}</h1>
    <h2 {...{
      "id": "admingraphql-1"
    }}>{`Admin(GraphQL)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/graphql`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start:prod`}</inlineCode></li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/admin/graphql`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start`}</inlineCode></li>
    </ol>
    <p><strong parentName="p">{`NOTE`}</strong>{` : API must be running for the above commands to work.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` : `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file must be filled with your values.`}</p>
    <h2 {...{
      "id": "adminrest-1"
    }}>{`Admin(REST)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/rest`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start:prod`}</inlineCode></li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/admin/rest`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start`}</inlineCode></li>
    </ol>
    <p><strong parentName="p">{`NOTE`}</strong>{` : API must be running for the above commands to work.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` : `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file must be filled with your values.`}</p>
    <h2 {...{
      "id": "shopgraphql"
    }}>{`Shop(GraphQL)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/graphql`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start:prod`}</inlineCode></li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/shop`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build:gql`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start`}</inlineCode></li>
    </ol>
    <p><strong parentName="p">{`NOTE`}</strong>{` : API must be running for the above commands to work.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` : `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file must be filled with your values.`}</p>
    <h2 {...{
      "id": "shoprest"
    }}>{`Shop(REST)`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/api/rest`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start:prod`}</inlineCode></li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`/shop`}</inlineCode>{` folder.`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn build:rest`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn start`}</inlineCode></li>
    </ol>
    <p><strong parentName="p">{`NOTE`}</strong>{` : API must be running for the above commands to work.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` : `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file must be filled with your values.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      